exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":root{--regions-filter-width:225px}:root[data-color-mode=light]{--background:#fafafa;--text-color:#111517;--background-component:#fff;--input-placeholder:#858585}:root[data-color-mode=dark]{--background:#202c37;--text-color:#fff;--background-component:#2b3945;--input-placeholder:#fff}:root[data-color-mode=dark] .header__icon>path{fill:var(--text-color)!important;stroke:var(--text-color)!important}*{box-sizing:border-box;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}html{height:100%;font-size:100%;color:var(--text-color);background-color:var(--background)}h1,h2,h3,h4,h5,html{font-family:Nunito Sans,sans-serif}h1,h2,h3,h4,h5{font-weight:800;line-height:1.15}h1{font-size:3.052em}h2{font-size:2.441em}h3{font-size:1.953em}h4{font-size:1.563em}h5{font-size:1.25em}.text_small,small{font-size:.8em}img{max-width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/styles/global.css
// module id = 21
// module chunks = 0